export class StringHelpers {

  static removeDiacritics(str: string): string {
    const noHtml = str.replace(/<[^>]*>/g, '');
    const noDiacritics = noHtml.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    return noDiacritics.toLowerCase();
  }
}
